@if (url()) {
  <img class="w-full h-full object-cover" [src]="url()" alt="">
} @else {
  <div class="flex w-full h-full bg-gray-lighten justify-center items-center">
    <app-icon [name]="placeholderIconName()" class="text-[140px] text-gray"></app-icon>
  </div>
}
